import SubledgerBalances from './SubledgerBalances';
import AccountRates from './AccountRates';
import InstalmentPlans from './InstalmentPlans';
import BNPLs from './BNPLs';
import PaymentDayChange from './PaymentDayChange';
import CreditLimitIncreasePreferenceUpdate from './CreditLimitIncreasePreferenceUpdate';
import { useContext } from 'react';
import { Segment, Tab } from 'semantic-ui-react';
import { AccountStatus } from './AccountStatus';
import { AccountBrief } from './AccountBrief';
import CustomerSummary from './CustomerSummary';
import { AccountIdContext } from '../AccountIdContext';
export default function AccountDetail() {

  const {paymentDueDateStrategy} = useContext(AccountIdContext);


  return (
    <Segment>
      <div className="ui grid">
        <div className="three wide column">
          <div className="ui cards">
            <AccountBrief />
            <AccountRates />
          </div>
        </div>
        <div className="ten wide column">
          <Tab
            panes={[
              {
                menuItem: 'Subledger Balances',
                render: () => (
                  <Tab.Pane>
                    <SubledgerBalances />
                  </Tab.Pane>
                ),
              },
              {
                menuItem: 'Instalment Plans',
                render: () => (
                  <Tab.Pane>
                    <InstalmentPlans />
                  </Tab.Pane>
                ),
              },
              {
                menuItem: 'BNPLs',
                render: () => (
                  <Tab.Pane>
                    <BNPLs />
                  </Tab.Pane>
                ),
              },
              {
                menuItem: `${paymentDueDateStrategy === 'Fixed' ? 'Payment' : 'Statement'} Day Change`,
                render: () => (
                  <Tab.Pane>
                    <PaymentDayChange />
                  </Tab.Pane>
                ),
              },
              {
                menuItem: 'Credit Limit Increase Preference',
                render: () => (
                  <Tab.Pane>
                    <CreditLimitIncreasePreferenceUpdate />
                  </Tab.Pane>
                ),
              },
            ]}
          />
        </div>
        <div className="three wide column">
          <CustomerSummary />
        </div>
      </div>
    </Segment>
  );
}
